import React, { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useParams,
  Navigate,
} from "react-router-dom";
import NotFound from "./components/Common/NotFound";
import Index from "./components/Index";
import LandingPage from "./components/LandingPage/Index";
import CallWaiter from "./components/CallWaiter/Index";
import DocumentViewer from "./components/DocumentViewer";
import MenuPage from "./components/MenuPage/Index";
import PaymentPage from "./components/PaymentPage/Index";
import PaymentResult from "./components/PaymentPage/PaymentResult";
import CheckSummery from "./components/CheckSummery/Index";
import CommingSoon from "./components/CommingSoon/Index";

import ViewMenuOptions from "./components/ViewMenuOptions/Index";

const App = () => {
  const urlParams = useParams();
  useEffect(() => {
    if (Object.keys(urlParams).length) {
      sessionStorage.setItem("urlParams", JSON.stringify(urlParams));
    }
  }, [urlParams]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/ezmenu/options/:tableNumer/:rvc/:zone/:actualTableNumber" element={<ViewMenuOptions />} />
          <Route path="/ezmenu/:tableNumer/:rvc/:zone/:actualTableNumber" element={<Index />} />
        <Route path="/ezmenu/payment" element={<PaymentPage />} />
        <Route path="/ezmenu/payment/result" element={<PaymentResult />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/home/menu" element={<MenuPage />} />
        <Route path="/check-summery" element={<CheckSummery />} />
        <Route path="/call-waiter" element={<CallWaiter />} />
        <Route path="/comming-soon" element={<CommingSoon />} />
        <Route path="/view-document/:doc" element={<DocumentViewer />} />
        <Route path="*" element={<NotFound />} />
        {/* <Route path="/:tableNumer/:rvc/:zone/:actualTableNumber" element={<Index />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/payment/result" element={<PaymentResult />} />
        <Route path="/home" element={<LandingPage />} />
        <Route path="/home/menu" element={<MenuPage />} />
        <Route path="/check-summery" element={<CheckSummery />} />
        <Route path="/call-waiter" element={<CallWaiter />} />
        <Route path="/comming-soon" element={<CommingSoon />} />
        <Route path="/view-document/:doc" element={<DocumentViewer />} />
        <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default App;